import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientAssignmentJobEntity } from './client-assignment-job.entity';
import { ClientEntity } from './client.entity';
import { UserEntity } from './user.entity';

@Index('client_assignment_history__fk_client__id_fk', ['fkClientId'], {})
@Index(
	'client_assignment_history__fk_client_assignment_job__id_fk',
	['fkClientAssignmentJobId'],
	{},
)
@Index(
	'client_assignment_history_pk',
	['fkUserId', 'fkClientId', 'fkClientAssignmentJobId'],
	{ unique: true },
)
@Entity('client_assignment_history')
export class ClientAssignmentHistoryEntity extends BaseEntity {
	@Column('varchar', { name: 'action', length: 255 })
	public action!: string;

	@Column('int', { name: '_fk_user__id', unsigned: true })
	public fkUserId!: number;

	@Column('int', { name: '_fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('int', { name: '_fk_client_assignment_job__id', unsigned: true })
	public fkClientAssignmentJobId!: number;

	@ManyToOne(
		() => ClientAssignmentJobEntity,
		(clientAssignmentJob) => clientAssignmentJob.clientAssignmentHistories,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk_client_assignment_job__id', referencedColumnName: 'id' },
	])
	public fkClientAssignmentJob!: ClientAssignmentJobEntity;

	@ManyToOne(() => ClientEntity, (client) => client.clientAssignmentHistories, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;

	@ManyToOne(() => UserEntity, (user) => user.clientAssignmentHistories, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity;
}
